export const colorsCode = {
    success: '#39c44a',
    warning: '#fde000',
    error: '#e62e43',
  };

export const colors = {
    SUCCESS: 'success',
    WORKING: 'warning',
    BUSY: 'error',
  };
  
export interface Status {
    working: string;
    busy: string;
    available: string;
}

export const status: Status = {
    working: colors.WORKING,
    busy: colors.BUSY,
    available: colors.SUCCESS,
};
  

export const CONVERSATION_SEARCH_HEIGHT = 50; 
export const CONVERSATION_CONTAINER_HEADER_HEIGHT =  48;
export const CONVERSATION_CONTAINER_REPLYBOX_HEIGHT = 100; 
export const CONVERSATION_CONTAINER_FOOTER_HEIGHT = 40; 